const STORAGE_KEY = 'notifications:seenIds'
// Caps unbounded growth for long-lived accounts; well above realistic list sizes
// (notifications are paginated 30/page) so effectively permanent in practice.
const MAX_STORED_IDS = 500

const readSeenIds = (): string[] => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        return raw ? JSON.parse(raw) : []
    } catch {
        return []
    }
}

const writeSeenIds = (ids: string[]) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(-MAX_STORED_IDS)))
    } catch {
        /* ignore persistence errors (private mode / disabled storage) */
    }
}

/**
 * Tracks notifications the user has opened at least once, independent of the
 * backend `readAt` field — which the "Segna da leggere" toggle resets to null.
 * The unread dot must disappear the first time a notification is opened and
 * never come back, even if it's later marked unread again via that toggle.
 */
export const hasBeenSeen = (id: string): boolean => readSeenIds().includes(id)

export const markAsSeen = (id: string) => {
    const ids = readSeenIds()
    if (ids.includes(id)) return
    writeSeenIds([...ids, id])
}
